import { css } from 'styled-components';

export default css`
  #cdic-ok-checker-badge {
    border: 0;
    display: inline-block;
    position: relative;
  }
  #ok-checker-sign-image {
    border: 0;
  }
  #ok-checker-link {
  }
`;
